import { render, staticRenderFns } from "./BetgameEditSpecialQuestionDetail.vue?vue&type=template&id=3d864059&scoped=true"
import script from "./BetgameEditSpecialQuestionDetail.vue?vue&type=script&lang=js"
export * from "./BetgameEditSpecialQuestionDetail.vue?vue&type=script&lang=js"
import style0 from "./BetgameEditSpecialQuestionDetail.vue?vue&type=style&index=0&id=3d864059&prod&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3d864059",
  null
  
)

export default component.exports